import DeactivateInvestorGoalError from './DeactivateInvestorGoalError';
export default DeactivateInvestorGoalError;
